import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'
import { getAccessToken } from '../service/AuthService';

const PrivateRoutes = () => {
    return (
        getAccessToken() ? <Outlet/>
        : <Navigate to={{ pathname: '/login'}} />     
    )
}

export default PrivateRoutes;